import React, { createContext } from 'react';

interface ShowSubContextType {
  showSub: boolean;
  setShowSub: React.Dispatch<React.SetStateAction<boolean>>;
}

const ShowSubContext = createContext<ShowSubContextType | undefined>(undefined);

export default ShowSubContext;
